import React from 'react';
import PropTypes from 'prop-types';

const Sad = ({
  className,
  color,
}) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className={className}>
    <path
      fill={color}
      d="M8 11V9a1 1 0 0 1 2 0v2a1 1 0 0 1-2 0zm7 1a1 1 0 0 0 1-1V9a1
        1 0 0 0-2 0v2a1 1 0 0 0 1 1zm-3 2a6.036 6.036 0 0 0-4.775 2.368 1 1 0
        1 0 1.55 1.264 4 4 0 0 1 6.45 0 1 1 0 0 0 1.55-1.264A6.036 6.036 0 0 0
        12 14zm11-2A11 11 0 1 1 12 1a11.013 11.013 0 0 1 11 11zm-2 0a9 9 0 1 0-9
        9 9.01 9.01 0 0 0 9-9z"
    />
  </svg>
);

Sad.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
};

Sad.defaultProps = {
  className: '',
  color: 'white',
};

export default Sad;
